import { Link } from "react-router-dom";
import { Icon, IconType } from "../../../common/icons/Icon";
import { RenderWhen } from "../../../common/infrastructure/components/RenderWhen";
import { constructSupportChatHref } from "../../../common/infrastructure/routes/routePaths";
import { IAiSupportTicket, aiAssistantTexts } from "../models/aiAssistantModels";
import styles from "./AiMessages.module.scss";

interface IAiSupportTicketCardProps {
  ticket: IAiSupportTicket;
}

/** The ticket the assistant created itself (the user agreed in the chat): a short note and its link. */
export const AiSupportTicketCard = ({ ticket }: IAiSupportTicketCardProps) => (
  <section className={styles.ticket} aria-label={aiAssistantTexts.ticketCreated}>
    <div className={styles.ticket_header}>
      <span className={styles.ticket_icon} aria-hidden="true">
        <Icon type={IconType.CheckmarkSentIcon} width="14px" height="14px" color="currentColor" />
      </span>
      <span>{aiAssistantTexts.ticketCreated}</span>
    </div>
    <div className={styles.ticket_row}>
      <RenderWhen condition={!!ticket.title}>
        <span className={styles.ticket_title} title={ticket.title}>
          {ticket.title}
        </span>
      </RenderWhen>
      <Link className={styles.ticket_link} to={constructSupportChatHref(ticket.id)}>
        {aiAssistantTexts.draftOpen}
      </Link>
    </div>
  </section>
);
